import { BackofficeUserBrandingSettings } from "./user-branding";
import {UserBrandingSetting} from './user-branding-setting';

export abstract class IUserBrandingRepository {
  abstract getBackofficeUserBrandingSettingForCurrentDomain(
    domainName: string,
  ): Promise<BackofficeUserBrandingSettings>;

  abstract delete(domainNameAsUid: string): Promise<boolean>;
  abstract upsert(userBrandingSetting: UserBrandingSetting): Promise<boolean>;
  abstract getAll(): Promise<UserBrandingSetting[]>;
}
